<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Administration</a>
                </li>
                <li class="breadcrumb-item">
                  <router-link to="/administration/setting">
                    Global Settings
                  </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Terms & Conditions
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Terms & Conditions
                    <span><i class="ic-settings-horizontal"></i></span>
                  </h2>
                  <p>
                    Set all necessary parameters and configurations to support
                    your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <form @submit.prevent="onSubmit()">
            <div class="col-sm-8">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="required">Title</label>
                  <input
                    :class="{
                      'field-error': isSubmitted && !$v.model.title.required,
                    }"
                    type="text"
                    class="form-control"
                    name="title"
                    v-model="model.title"
                  />
                  <small
                    class="form-text sts-danger"
                    v-if="isSubmitted && !$v.model.title.required"
                    style="display: block"
                  >
                    Title is required
                  </small>
                </div>
                <div class="form-group">
                  <label class="">Deadline Date</label>
                  <VueCtkDateTimePicker
                    id="deadline-date"
                    :min-date="minimumDeadlineDate"
                    v-model="model.deadlineDate"
                    color="#025BC5"
                    format="YYYY-MM-DD"
                    formatted="MMM DD, YYYY"
                    auto-close
                    only-date
                    no-label
                    no-header
                    no-button
                    no-button-now
                  />
                </div>
                <div class="form-group">
                  <label class="required">Content</label>
                  <quill-editor
                    :class="{
                      'field-error': isSubmitted && !$v.model.content.required,
                    }"
                    ref="myQuillEditor"
                    v-model="model.content"
                    :options="editorOption"
                  />
                  <small
                    class="form-text sts-danger"
                    v-if="isSubmitted && !$v.model.content.required"
                    style="display: block"
                  >
                    Content is required
                  </small>
                </div>
              </div>
            </div>
            <div class="col-sm-4 postick">
              <button type="submit" class="btn btn-primary btn-custom-submit">
                Submit
              </button>

              <div class="option-action-wrapper">
                <div class="option-action" @click="saveToDraft()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 32 32"
                  >
                    <path d="M8 6h12v2H8z" fill="currentColor"></path>
                    <path d="M8 10h12v2H8z" fill="currentColor"></path>
                    <path d="M8 14h6v2H8z" fill="currentColor"></path>
                    <path d="M8 24h4v2H8z" fill="currentColor"></path>
                    <path
                      d="M29.707 19.293l-3-3a1 1 0 0 0-1.414 0L16 25.586V30h4.414l9.293-9.293a1 1 0 0 0 0-1.414zM19.586 28H18v-1.586l5-5L24.586 23zM26 21.586L24.414 20L26 18.414L27.586 20z"
                      fill="currentColor"
                    ></path>
                    <path
                      d="M12 30H6a2.002 2.002 0 0 1-2-2V4a2.002 2.002 0 0 1 2-2h16a2.002 2.002 0 0 1 2 2v10h-2V4H6v24h6z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  <span>Save to Draft</span>
                </div>
                <div class="option-action" @click="onPreview(model)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1024 1024"
                  >
                    <path
                      d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  <span>Preview</span>
                </div>
              </div>

              <div
                id="draft"
                class="history-list-wrapper"
                v-if="live && (live.content || live.title)"
              >
                <h4 class="history-title">Published</h4>
                <ul>
                  <li
                    class="list-terms-conditions"
                    :class="live.id === model.id && 'active-list-item'"
                  >
                    <div class="version-badge">V{{ live.version }}</div>

                    <div class="description-list-tnc-wrapper">
                      <div class="author-tnc">
                        Uploaded by {{ live.publishedBy }}
                      </div>
                      <span class="date-time-tnc">{{
                        live.modifiedDate | momentDate
                      }}</span>
                    </div>
                    <div class="action-draft-history">
                      <button
                        type="button"
                        class="btn-preview"
                        @click="onEdit(live)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>

              <div
                id="draft"
                class="history-list-wrapper"
                v-if="draft && (draft.content || draft.title)"
              >
                <h4 class="history-title">Draft</h4>
                <ul>
                  <li
                    class="list-terms-conditions"
                    :class="draft.id === model.id && 'active-list-item'"
                  >
                    <div class="version-badge">V{{ draft.version }}</div>

                    <div class="description-list-tnc-wrapper">
                      <div class="author-tnc">
                        Uploaded by {{ draft.publishedBy }}
                      </div>
                      <span class="date-time-tnc">{{
                        draft.modifiedDate | momentDate
                      }}</span>
                    </div>
                    <div class="action-draft-history">
                      <button
                        type="button"
                        class="btn-preview"
                        @click="onEdit(draft)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>

              <div
                id="history"
                class="history-list-wrapper"
                v-if="history.length"
              >
                <h4 class="history-title">History</h4>
                <ul>
                  <li
                    class="list-terms-conditions"
                    :class="item.id === model.id && 'active-list-item'"
                    v-for="(item, idx) in history"
                    :key="idx"
                  >
                    <div class="version-badge">V{{ item.version }}</div>

                    <div class="description-list-tnc-wrapper">
                      <div class="author-tnc">
                        Uploaded by {{ item.publishedBy }}
                      </div>
                      <span class="date-time-tnc">{{
                        item.modifiedDate | momentDate
                      }}</span>
                    </div>
                    <div class="action-draft-history">
                      <button
                        type="button"
                        class="btn-preview"
                        @click="onEdit(item)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Modal -->
    <div class="modal fade" role="dialog" ref="confirmationModal">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div
                  class="d-flex items-center"
                  style="justify-content: flex-end"
                >
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="modal-confirmation-wrapper">
                    <h3 class="title-confirmation">Publish Confirmation</h3>
                    <p class="description-confirmation">
                      Please ensure the content has been
                      <span>previewed</span> and is correct. Are you sure you
                      want to publish?
                    </p>

                    <div class="button-confirmation-wrapper">
                      <button
                        type="button"
                        class="btn btn-cancel"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn-publish"
                        @click="onPublish()"
                      >
                        Publish
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="previewModal">
      <div class="modal-dialog modal-md custom">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4 class="title-preview">{{ previewData.title }}</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="modal-preview-wrapper">
                    <div v-html="previewData.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import termsConditionService from "@/services/master/termsCondition/termsConditionService.js";

export default {
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  validations() {
    const v = {
      model: {
        id: {},
        title: { required },
        deadlineDate: {},
        content: { required },
        createdDate: {},
        modifiedDate: {},
      },
    };

    return v;
  },
  data() {
    return {
      editorOption: {
        modules: {
          clipboard: {
            matchVisual: false,
          },
        },
      },
      previewData: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null,
      },
      model: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null,
      },
      draft: {
        content: "",
        deadlineDate: null,
        createdDate: null,
        modifiedDate: null,
        id: null,
        title: null,
      },
      live: {
        content: "",
        deadlineDate: null,
        createdDate: null,
        modifiedDate: null,
        id: null,
        title: null,
      },
      history: [],
      minimumDeadlineDate: null,
      isSubmitted: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.$helper.scrollTop();

    this.minimumDeadlineDate = this.$helper.toStringDate(
      this.$helper.addDays(1)
    );

    await this.getAll();
  },
  methods: {
    async getAll() {
      try {
        this.isLoading = true;
        const response = await termsConditionService.getAll();

        if (response.isSuccess) {
          this.live = response.data.live;
          this.draft = response.data.draft;
          this.history = response.data.history.sort(
            (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
          );

          this.model = {
            id:
              response.data.latest && response.data.latest.id
                ? response.data.latest.id
                : null,
            title:
              response.data.latest && response.data.latest.title
                ? response.data.latest.title
                : null,
            deadlineDate:
              response.data.latest && response.data.latest.deadlineDate
                ? moment(response.data.latest.deadlineDate).format("YYYY-MM-DD")
                : null,
            content:
              response.data.latest && response.data.latest.content
                ? response.data.latest.content
                : null,
            createdDate:
              response.data.latest && response.data.latest.createdDate
                ? response.data.latest.createdDate
                : null,
            modifiedDate:
              response.data.latest && response.data.latest.modifiedDate
                ? response.data.latest.modifiedDate
                : null,
          };
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onSubmit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }

      $(this.$refs.confirmationModal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async onPublish() {
      this.isLoading = true;
      try {
        const payload = {
          ...this.model,
          deadlineDate: this.model.deadlineDate
            ? moment(this.model.deadlineDate).format("YYYY-MM-DDTHH:mm:ss")
            : null,
        };

        const response = await termsConditionService.publish(payload);

        if (response.isSuccess) {
          this.$notification.success(
            "Successfully publish terms & condition.",
            {
              title: "Success",
            }
          );
          this.$router.push({ path: "/administration/setting" });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        $(this.$refs.confirmationModal).modal("hide");
      }
    },
    async saveToDraft() {
      this.isLoading = true;
      try {
        const response = await termsConditionService.saveToDraft(this.model);

        if (response.isSuccess) {
          this.$notification.success("Successfully saved to draft.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getAll();
      }
    },
    onPreview(data) {
      this.previewData = data;

      $(this.$refs.previewModal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    onEdit(data) {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
      this.model = {
        ...data,
        deadlineDate: data.deadlineDate
          ? moment(data.deadlineDate).format("YYYY-MM-DD")
          : null,
      };
    },
  },
  filters: {
    momentDate: function (time) {
      return moment(time).parseZone().format("D MMMM YYYY hh:mm:ss");
    },
  },
};
</script>
<style scoped>
.btn-custom-submit {
  height: 40px !important;
  width: 100% !important;
  margin-top: 27px;
}

.option-action-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
}

.option-action {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: max-content;
  padding: 7px;
  border-radius: 5px;
}

.option-action:hover {
  background: #edf6ec;
}

.option-action:active {
  background: #4fb848;
  color: #fff;
}

.option-action:active span {
  color: #fff;
}

.option-action svg {
  width: 24px;
  height: 24px;
}

.option-action span {
  font-size: 14px;
  font-weight: 400;
  color: #000;
}

.modal-confirmation-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.modal-confirmation-wrapper .title-confirmation {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #000;
}

.modal-confirmation-wrapper .description-confirmation {
  text-align: center;
  width: 60%;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  margin-top: 10px;
}

.modal-confirmation-wrapper .description-confirmation span {
  color: #4fb848;
}

.button-confirmation-wrapper {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.button-confirmation-wrapper .btn-cancel,
.button-confirmation-wrapper .btn-publish {
  border: 1px solid #edf6ec;
  background: #fff;
  color: #eb0011;
  height: 35px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 900;
}

.button-confirmation-wrapper .btn-publish {
  border: 1px solid #4fb848;
  background: #4fb848;
  color: #fff;
}

.button-confirmation-wrapper .btn-cancel:hover {
  background: #eb0011;
  border: 1px solid #eb0011;
  color: #fff;
}

.button-confirmation-wrapper .btn-publish:hover {
  background: #edf6ec;
  color: #4fb848;
}

.history-list-wrapper {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #999999;
  margin-top: 30px;
  padding: 5px 0 0 0;
}

.history-list-wrapper .history-title {
  width: 100%;
  padding: 0 10px;
  font-size: 1.067rem;
  font-weight: 700;
  color: #4a4a4a;
}

.history-list-wrapper ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 3px 10px;
  list-style: none;
}

.history-list-wrapper ul li .action-draft-history {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.history-list-wrapper ul li span {
  color: #808080;
  font-size: 13px;
  font-weight: 400;
}

.history-list-wrapper ul li .action-draft-history button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 3px;
  border: none;
  border-radius: 3px;
}

.history-list-wrapper ul li .action-draft-history button:hover {
  background: #edf6ec;
}

.history-list-wrapper ul li .action-draft-history button svg {
  color: #363636;
  width: 17px;
}

.list-terms-conditions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 5px;
  overflow: hidden;
  border-bottom: 0.5px solid #ddd;
}

ul li.list-terms-conditions:not(:first-child) {
  margin-top: 15px;
}

ul li.list-terms-conditions.active-list-item {
  border-bottom: none;
  border-radius: 5px;
  border: 1px dotted #4fb848;
  background: #4fb848;
}

ul li.list-terms-conditions.active-list-item .author-tnc,
ul li.list-terms-conditions.active-list-item .date-time-tnc {
  color: #edf6ec;
}

ul li.list-terms-conditions.active-list-item button {
  border: 1px dotted #edf6ec;
}

ul li.list-terms-conditions.active-list-item button svg {
  color: #edf6ec;
}

ul li.list-terms-conditions.active-list-item button:hover svg {
  color: #4fb848;
}

.list-terms-conditions .version-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 45px;
  border-radius: 5px;
  background: #edf6ec;
  color: #4fb848;
  font-weight: 800;
  font-size: 20px;
}

.description-list-tnc-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 73%;
}

.description-list-tnc-wrapper .author-tnc {
  font-size: 12px;
  font-weight: 600;
}

.description-list-tnc-wrapper .date-time-tnc {
  font-size: 11px;
}

@media (min-width: 768px) {
  .modal-md.custom {
    width: 800px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/master/setting/TermConditionsForm.vue